import axios from 'axios';

export default {
    data() {
        return {
            image_path: 'https://show.guyanalive.com/',
            albums: [],
            title: '',
            errors: [],
        };
    },

    // Fetches posts when the component is created.
    created() {
        window.scrollTo(0, 0);
        this.getAlbum(this.$route.params.category);
    },
    methods: {
        getAlbum(path) {
            axios
                .get(
                    `https://show.guyanalive.com/index.php?album=${
                        path
                    }&json&pagination=off`,
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.albums = response.data.album.albums;
                    this.title = response.data.album.title;
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/category/category.page.js